class Dialogs {
    static SELECTORS = {
        openDialogOnLoad: '[data-open-dialog-on-load]'
    }
    constructor() {
        this.openModalDialogs()
    }

    openModalDialogs() {
        // Shopify exposes errors and success only inside its generated form block.
        // A form snippet therefore renders this marker when a postback should reopen
        // its dialog, and the helper promotes the nearest dialog with showModal() so
        // it enters the top layer, receives modal focus handling, and gets a backdrop.
        document.querySelectorAll(Dialogs.SELECTORS.openDialogOnLoad).forEach((marker) => {
            this.openModalDialog(marker.closest('dialog'))
        })
    }

    openModalDialog(dialog) {
        if (!dialog || typeof dialog.showModal !== 'function') {
            return
        }

        dialog.removeAttribute('open')
        dialog.showModal()
    }
}

document.addEventListener('DOMContentLoaded', () => new Dialogs())
